/* eslint-disable prefer-destructuring */
import React, { useContext, useState } from 'react';
import { VisitFees } from '@mummssoftware/common-ui';
import { handleNumericChange } from '@mummssoftware/utils/visitUtils';
import {
  SET_TRANSIT_FEES,
  SET_MILEAGE,
  SET_TRAVEL_TIME,
  SET_TOLLS_FEES,
  VisitsGlobalContext,
} from '@mummssoftware/global-context';

type EditFeesProps = {
  pastVisit: Record<string, any>;
};

export const EditFees = ({ pastVisit }: EditFeesProps) => {
  const { dispatchVG } = useContext(VisitsGlobalContext);
  const { mileage, tolls, traveltime, publictransit } = pastVisit;

  const [transitFee, setTransitFee] = useState<number>(publictransit || 0);
  const [mileagecount, setMileage] = useState<number>(mileage || 0);
  const [travelTime, setTravelTime] = useState<number>(traveltime || 0);
  const [tollFee, setTollFee] = useState<number>(tolls || 0);

  const onTransitFeeChange = handleNumericChange(
    setTransitFee,
    SET_TRANSIT_FEES,
    dispatchVG,
  );
  const onMileageChange = handleNumericChange(
    setMileage,
    SET_MILEAGE,
    dispatchVG,
  );
  const onTravelTimeChange = handleNumericChange(
    setTravelTime,
    SET_TRAVEL_TIME,
    dispatchVG,
  );
  const onTollFeeChange = handleNumericChange(
    setTollFee,
    SET_TOLLS_FEES,
    dispatchVG,
  );

  return (
    <>
      <VisitFees
        transitFees={transitFee}
        travelMileage={mileagecount}
        travelDuration={travelTime}
        tollsFee={tollFee}
        onTransitFeeChange={onTransitFeeChange}
        onMileageChange={onMileageChange}
        onTravelTimeChange={onTravelTimeChange}
        onTollFeeChange={onTollFeeChange}
      />
    </>
  );
};
